import React, { useEffect, useState } from 'react';
import wave1 from "../assets/wave1.png";
import wave2 from "../assets/wave2.png";
import firework2 from "../assets/firework2.gif";
import confetti from "../assets/confetti.gif";
import congrats from "../assets/congrats.webp";
import { Col, Row } from 'reactstrap';
import StarRatings from "react-star-ratings";
import callApi from '../../../../utils/apiCaller';
import config from '../../../../config/config';
import { useDispatch } from 'react-redux';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useSelector } from "react-redux";
import { actFecthYearEndWrap } from '../../../../actions';
import { GiftCardMajor } from '@shopify/polaris-icons';
import Confetti from '../../../Dashboard/christmas/Confetti';
gsap.registerPlugin(ScrollTrigger);

const Slide4 = () => {
  const { dataSettings} = useSelector(state => state)
  const [rating, setRating] = useState(0);
  const [checkReview, setcheckReview] = useState(false);
  const [clickMode, setclickMode] = useState("year_end");
  const dispatch = useDispatch();

  const customer = dataSettings?.shop_name;

  const changeRating = (star) => {
    setRating(star);
    // console.log("star", star);
    let params = {
      action: "clickReview",
      type: clickMode,
      note: star,
    };
    callApi("get", params).then(async (res) => { });
    if (star === 5) {
      let reviewUrl = config.liveAppUrl + "#modal-show=ReviewListingModal";
      // if (config.platform === "WOO_COMMERCE") {
      //   reviewUrl =
      //     "https://wordpress.org/support/plugin/omega-add-paypal-tracking-for-woocommerce/reviews/";
      // }
      window.open(reviewUrl, "_blank");
      setcheckReview(true);
    } else {
      setcheckReview(true);
    }
    dispatch(actFecthYearEndWrap(false));
    if (config.checkLocalStorage) {
      localStorage.setItem("st_year_end_wrap_2022", 2);
    }
  };
  
  useEffect(() => {
    const scroll = {
      scroller: ".st-year-end-slides-scroll",
      trigger: ".year-wrap-slide-4",
      // markers: true,
      start: "top center",
      toggleActions: "restart none none reverse",
    };
    gsap.fromTo(
      ".d-description",
      { y: 200, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 3,
        scrollTrigger: scroll,
      },
    );
  }, [])
  return (
    <div className="year-wrap-slide-4">
      <div className="position-absolute top-0">
        <img src={wave1} />
      </div>
      <div className="position-absolute bottom-0 w-100">
        <img src={wave2} />
      </div>
      <div className="position-absolute top-0 left-0 w-100">
        <Confetti />
      </div>
      <div className="w-80 m-auto">
        <Row>
          <Col
            lg={7}
            className="d-flex flex-column justify-content-center"
          >
            <div className="text-center">
              <div>
                <span className="d-text-blue1 d-text-30 d-text-blue2">
                  Dear <b>{customer}</b>, congrats on all the great thing
                  you’ve done in 2022. We are so lucky to have you.
                  <br /> Here's to a super duper amazing 2023!
                </span>
              </div>
              <div className="d-pt-10 d-description">
                <span className="d-text-25">
                  How do you rate your experience with Synctrack in 2022?
                </span>
                <div className="text-center mt-3">
                  <StarRatings
                    rating={rating}
                    starEmptyColor="rgba(255, 255, 255, 0.7)"
                    starRatedColor="#ffcb0d"
                    starHoverColor="#ffcb0d"
                    starDimension="50px"
                    starSpacing="5px"
                    changeRating={changeRating}
                    numberOfStars={5}
                    name="rating"
                    svgIconPath="M55.4631 24.4912C56.1022 24.0186 56.5763 23.3592 56.8189 22.6057C57.0614 21.8521 57.0603 21.042 56.8157 20.2891C56.5711 19.5362 56.0953 18.8781 55.4549 18.4072C54.8145 17.9363 54.0417 17.6762 53.2449 17.6633L37.7686 17.0829C37.6925 17.0777 37.6195 17.0507 37.5585 17.0053C37.4975 16.9599 37.451 16.8979 37.4247 16.8268L32.0767 2.48819C31.808 1.75869 31.32 1.12877 30.6787 0.683728C30.0374 0.238681 29.2739 0 28.4914 0C27.7089 0 26.9454 0.238681 26.3041 0.683728C25.6628 1.12877 25.1748 1.75869 24.9061 2.48819L19.5753 16.878C19.549 16.9491 19.5025 17.0111 19.4415 17.0565C19.3805 17.1019 19.3075 17.1289 19.2314 17.1341L3.75514 17.7145C2.9583 17.7274 2.1855 17.9875 1.54512 18.4584C0.904736 18.9294 0.428877 19.5874 0.184266 20.3403C-0.0603455 21.0933 -0.061443 21.9033 0.181127 22.6569C0.423698 23.4105 0.897772 24.0698 1.53688 24.5424L13.6772 34.0161C13.7379 34.0636 13.7833 34.1277 13.8078 34.2005C13.8322 34.2733 13.8346 34.3517 13.8147 34.4258L9.63613 49.1229C9.4196 49.8713 9.44057 50.6678 9.69621 51.404C9.95185 52.1401 10.4297 52.7802 11.0648 53.2372C11.7 53.6942 12.4615 53.9459 13.2458 53.958C14.0301 53.9702 14.7992 53.7422 15.4483 53.305L28.2765 44.7701C28.3396 44.7268 28.4146 44.7036 28.4914 44.7036C28.5682 44.7036 28.6432 44.7268 28.7064 44.7701L41.5345 53.305C42.1748 53.7571 42.9411 54 43.7269 54C44.5127 54 45.279 53.7571 45.9194 53.305C46.5547 52.8523 47.033 52.2154 47.2886 51.4817C47.5442 50.7481 47.5645 49.9538 47.3467 49.2083L43.1337 34.46C43.1114 34.3859 43.1126 34.3068 43.1372 34.2335C43.1618 34.1602 43.2086 34.0962 43.2713 34.0503L55.4631 24.4912Z"
                    svgIconViewBox="0 0 60 60"
                  />
                </div>
              </div>
            </div>
          </Col>
          <Col lg={5}>
            <div className="position-relative">
              <div className="rounded-circle fit-content bg-white p-4 w-60">
                <img src={congrats} />
              </div>
              <div className="position-absolute top-0 left-0 w-40">
                <img src={firework2} />
              </div>
              <div className="position-absolute top--10 left-25 w-60">
                <img src={firework2} />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Slide4;